export const Sort = ({className}: {className?: string}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.75 4C13.9489 4 14.1397 4.07902 14.2803 4.21967L16.7803 6.71967C17.0732 7.01256 17.0732 7.48744 16.7803 7.78033C16.4874 8.07322 16.0126 8.07322 15.7197 7.78033L14.5 6.56066V15.25C14.5 15.6642 14.1642 16 13.75 16C13.3358 16 13 15.6642 13 15.25V6.56066L11.7803 7.78033C11.4874 8.07322 11.0126 8.07322 10.7197 7.78033C10.4268 7.48744 10.4268 7.01256 10.7197 6.71967L13.2197 4.21967C13.3603 4.07902 13.5511 4 13.75 4ZM6.25 4C6.66421 4 7 4.33579 7 4.75L7 13.4393L8.21967 12.2197C8.51256 11.9268 8.98744 11.9268 9.28033 12.2197C9.57322 12.5126 9.57322 12.9874 9.28033 13.2803L6.78033 15.7803C6.63968 15.921 6.44891 16 6.25 16C6.05109 16 5.86032 15.921 5.71967 15.7803L3.21967 13.2803C2.92678 12.9874 2.92678 12.5126 3.21967 12.2197C3.51256 11.9268 3.98744 11.9268 4.28033 12.2197L5.5 13.4393L5.5 4.75C5.5 4.33579 5.83579 4 6.25 4Z"
      fill="#222222"
    />
  </svg>
);
